import {z} from 'zod';

export type GetCustomTenantCatalogueApiResponse = /** status 200  */ {
  [key: string]: VehicleTypeResponseBody;
};

export type ModelFamilyResponseBody = {
  isCustom: boolean;
};

export type MakeResponseBody = {
  models: {
    [key: string]: ModelFamilyResponseBody;
  };
  isCustom: boolean;
};

export type VehicleTypeResponseBody = {
  makes: {
    [key: string]: MakeResponseBody;
  };
};

export type CustomCatalogueEntryUsageResponseBody = {
  vehicleType: string;
  /** Decided make - the custom text when present, otherwise the official catalogue key. */
  make: string;
  isCustomMake: boolean;
  /** Decided model family - the custom text when present, otherwise the official catalogue key. */
  modelFamily: string;
  isCustomModelFamily: boolean;
  vehicleCount: number;
};

export type GetCustomTenantCatalogueUsageApiResponse =
  /** status 200  */ CustomCatalogueEntryUsageResponseBody[];

export type ModelFamilyMappingRequestBody = {
  modelFamily: string;
  targetModelFamily: string | null;
};

export type RemapCustomMakeApiArg = {
  vehicleType: string;
  make: string;
  targetMake: string;
  /** Must cover every model family used under the source make. */
  modelFamilyMapping: ModelFamilyMappingRequestBody[];
};

export type RemapCustomModelFamilyApiArg = {
  vehicleType: string;
  /** Stays untouched by this operation. */
  make: string;
  modelFamily: string;
  targetModelFamily: string;
};

export const TrimLevelsResponseBodySchema = z.object({
  // The catalogue answers `{}` when a model family has no trims.
  trim_levels: z.array(z.object({const_key: z.string(), label: z.string()})).nullish(),
});

export type TrimLevelOption = {value: string; label: string};

export type GetTrimLevelsApiArg = {
  /** Catalogue make key, for example MAKE_BMW. */
  make: string;
  /** Catalogue model family keys, for example MAKE_BMW-MODELFAMILY_X5. Empty means the whole make. */
  modelFamilies: string[];
};

export type GetTrimLevelsApiResponse = TrimLevelOption[];
